import React from 'react';

import Donut from '../../chart/Donut';

const NextCheckinReady = props => {
    if (!props.documents) {
        return null;
    }

    const countInReview = parseInt(props.documents['Review Ready'].count, 10);
    const countQReady = parseInt(props.documents['Q-Ready'].count, 10);
    const countQSubmitted = parseInt(props.documents['Q-Submit'].count, 10);
    const countMet = parseInt(props.documents['Q-Met'].count, 10);
    const countPrevalidated = parseInt(
        props.documents['Prevalidated'].count,
        10
    );
    const countNotStarted = parseInt(props.documents['Not Started'].count, 10);
    const countStarted = parseInt(props.documents['Started'].count, 10);
    const countRevisionRequired = parseInt(
        props.documents['Revision Required'].count,
        10
    );

    const allTotal =
        countInReview +
        countQReady +
        countQSubmitted +
        countMet +
        countPrevalidated +
        countNotStarted +
        countStarted +
        countRevisionRequired;
    const percentDone = Math.round(
        ((countQReady +
            countQSubmitted +
            countMet +
            countPrevalidated +
            countInReview) /
            allTotal) *
            100
    );

    const donutData = [
        {
            name: 'countInReview',
            count: countInReview,
            criticality: props.documents['Review Ready'].criticality,
        },
        {
            name: 'countQReady',
            count: countQReady,
            criticality: 'complete',
        },
        {
            name: 'countQSubmitted',
            count: countQSubmitted,
            criticality: 'complete',
        },
        {
            name: 'countMet',
            count: countMet,
            criticality: 'complete',
        },
        {
            name: 'countPrevalidated',
            count: countPrevalidated,
            criticality: 'complete',
        },
    ];

    return (
        <div className="NextCheckinReady">
            <div className="NextCheckinReady__chart">
                <Donut data={donutData} />
                <div className="NextCheckinReady__completed">
                    {percentDone}% Completed
                </div>
            </div>
            <div className="NextCheckinReady__legend">
                <ul>
                    <li>
                        <div
                            className={`NextCheckinReady__legend-item NextCheckinReady__legend-item-review-${
                                props.documents['Review Ready'].criticality
                            }`}
                        />
                        {countInReview} In Review
                    </li>

                    <li>
                        <div className="NextCheckinReady__legend-item NextCheckinReady__legend-item-qready" />
                        {countQReady} Q-Ready
                    </li>

                    <li>
                        <div className="NextCheckinReady__legend-item NextCheckinReady__legend-item-qsubmit" />
                        {countQSubmitted} Q-Submitted
                    </li>

                    <li>
                        <div className="NextCheckinReady__legend-item NextCheckinReady__legend-item-met" />
                        {countMet} Q-Met
                    </li>

                    <li>
                        <div className="NextCheckinReady__legend-item NextCheckinReady__legend-item-prevalidated" />
                        {countPrevalidated} Prevalidated
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default NextCheckinReady;
